import HasTabbed from 'has-tabbed';
import lodash from 'lodash';

import store from 'app/redux/store';
import { getViewportForWidth } from 'app/utils/viewports';
import { Actions } from 'app/redux/globals/actions';

const registerHasTabbed = () => {
  const tabbed = new HasTabbed('is-tabbed'); // eslint-disable-line no-unused-vars
};

const registerViewportWatcher = () => {
  const watchViewport = () => {
    const currentViewport = getViewportForWidth(window.innerWidth);

    if (currentViewport !== store.getState().globals.viewport) {
      store.dispatch(Actions.viewportChanged(currentViewport));
    }
  };

  window.addEventListener('resize', lodash.throttle(watchViewport));
};

const registerGlobals = () => {
  registerHasTabbed();
  registerViewportWatcher();
};

export default registerGlobals;



// WEBPACK FOOTER //
// ./src/utils/registerGlobals.js